/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Счётчики фраз класса
 * @export
 * @interface MktuClassWordsCount
 */
export interface MktuClassWordsCount {
  /**
   * Число фраз из справочника Ниццы
   * @type {number}
   * @memberof MktuClassWordsCount
   */
  niceWords: number
  /**
   * Число фраз вне справочника Ниццы
   * @type {number}
   * @memberof MktuClassWordsCount
   */
  notNiceWords: number
}

/**
 * Check if a given object implements the MktuClassWordsCount interface.
 */
export function instanceOfMktuClassWordsCount(
  value: object
): value is MktuClassWordsCount {
  if (!('niceWords' in value) || value['niceWords'] === undefined) return false
  if (!('notNiceWords' in value) || value['notNiceWords'] === undefined)
    return false
  return true
}

export function MktuClassWordsCountFromJSON(json: any): MktuClassWordsCount {
  return MktuClassWordsCountFromJSONTyped(json, false)
}

export function MktuClassWordsCountFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MktuClassWordsCount {
  if (json == null) {
    return json
  }
  return {
    niceWords: json['niceWords'],
    notNiceWords: json['notNiceWords'],
  }
}

export function MktuClassWordsCountToJSON(
  value?: MktuClassWordsCount | null
): any {
  if (value == null) {
    return value
  }
  return {
    niceWords: value['niceWords'],
    notNiceWords: value['notNiceWords'],
  }
}
